import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import {
  Chip,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
} from "@mui/material";
import WbSunnyTwoToneIcon from "@mui/icons-material/WbSunnyTwoTone";
import BedtimeTwoToneIcon from "@mui/icons-material/BedtimeTwoTone";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import {
  changeColor,
  changeFontFamily,
  changeTheme,
  Colors,
  Fonts,
  Themes,
} from "./SettingFileContants";
import "../Notifications/notifications.scss";

const SettingsDrawer = ({ onClose }) => {
  const [value, setValue] = React.useState("arial");

  const handleChangeFontFamily = (event) => {
    setValue(event.target.value);
    changeFontFamily(event.target.value);
  };

  const handleCloseClick = () => {
    onClose();
  };

  const handleClickColorChange = (color) => {
    changeColor(color);
  };

  const handleClickThemeChange = (theme) => {
    changeTheme(theme);
  };

  return (
    <>
      <div className="main-setting">
        <Typography className="font-16" color="text.primary" variant="body2">
          Settings
        </Typography>

        <IconButton aria-label="delete" onClick={() => handleCloseClick()}>
          <CloseIcon />
        </IconButton>
      </div>

      <Card className="card-width-300">
        <CardContent>
          <>
            <Typography
              className="font-16"
              color="text.primary"
              variant="body2"
            >
              Primary Color
            </Typography>

            <Grid container spacing={1} className="p-10">
              <Grid item xs={6}>
                <Chip
                  className="color-green"
                  label="Green"
                  onClick={(e) => handleClickColorChange(Colors.Green)}
                  variant="outlined"
                  icon={<div className="chip-info"></div>}
                />
              </Grid>
              <Grid item xs={6}>
                <Chip
                  className="color-blue"
                  label="Blue"
                  onClick={(e) => handleClickColorChange(Colors.Blue)}
                  icon={<div className="chip-blue"></div>}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={6}>
                <Chip
                  className="color-indigo"
                  label="Indigo"
                  onClick={(e) => handleClickColorChange(Colors.Indigo)}
                  variant="outlined"
                  icon={<div className="chip-indigo"></div>}
                />
              </Grid>
              <Grid item xs={6}>
                <Chip
                  className="color-olive"
                  label="Olive"
                  onClick={(e) => handleClickColorChange(Colors.Olive)}
                  variant="outlined"
                  icon={<div className="chip-olive"></div>}
                />
              </Grid>
            </Grid>

            <Typography
              className="font-16 pt-20"
              color="text.primary"
              variant="body2"
            >
              Color Scheme
            </Typography>

            <Grid container spacing={2} className="p-10">
              <Grid item xs={6}>
                <Chip
                  label="Light"
                  onClick={(e) => handleClickThemeChange(Themes.Light)}
                  variant="outlined"
                  icon={<WbSunnyTwoToneIcon />}
                />
              </Grid>
              <Grid item xs={6}>
                <Chip
                  label="Dark"
                  onClick={(e) => handleClickThemeChange(Themes.Dark)}
                  icon={<BedtimeTwoToneIcon />}
                  variant="filled"
                />
              </Grid>
            </Grid>

            <Typography
              className="font-familyN font-16 pt-20"
              color="text.primary"
              variant="body2"
            >
              Font Family
            </Typography>

            <FormControl className="p-10">
              <RadioGroup
                aria-labelledby="demo-controlled-radio-buttons-group"
                name="controlled-radio-buttons-group"
                value={value}
                onChange={handleChangeFontFamily}
              >
                <FormControlLabel
                  value={Fonts.Montserrat}
                  control={<Radio />}
                  label="Montserrat"
                />
                <FormControlLabel
                  value={Fonts.SansSerif}
                  control={<Radio />}
                  label="Sans Serif"
                />
                <FormControlLabel
                  value={Fonts.Roboto}
                  control={<Radio />}
                  label="Roboto"
                />
                <FormControlLabel
                  value={Fonts.OpenSans}
                  control={<Radio />}
                  label={"Open Sans"}
                />
              </RadioGroup>
            </FormControl>
          </>
        </CardContent>
      </Card>
    </>
  );
};

export default SettingsDrawer;
